

class CardProduct extends HTMLElement {

  constructor() {
    super();
    this.utils = new Utils();
    this.forms = new Set();
    this.colors = JSON.parse(window.colorCodes);
    this.maxProducts = 3;
    this.isDesktop = window.innerWidth > 1024;
  }

  async connectedCallback() {
    this.bindEvents();
    this.renderColors();
  }

  async renderColors() {

    if (!this.isDesktop) return;
    const response = await fetch(window.storefront.api_url, this.getColorQuery());
    const { data } = await response.json();

    const product = {
      id: this.id,
      handle: this.dataset.productHandle,
      colorCode: this.dataset.productColorCode,
      checked: 'checked'
    }

    const siblings = data.product?.products?.references?.nodes.map(edge => edge) || [];

    const result = siblings.map((sibling) => {
      return {
        id: sibling.id,
        handle: sibling.handle,
        colorCode: sibling.supplier_color?.value,
        checked: ''
      };
    })
    result.unshift(product)

    this.collocateColorSiblings(result);
  }

  collocateColorSiblings(result) {
    const colorSwatchesContainer = this.querySelector('[data-color-swatches]');

    if (!colorSwatchesContainer) return;
    const colorLeft = this.querySelector('[data-left-colors]');


    for (let i = 0; i < result.length && i < this.maxProducts; i++) {
      colorSwatchesContainer.innerHTML += this.getColorSibling(result[i]);
    }

    if (result.length > this.maxProducts) {
      colorLeft.innerHTML = '+' + (result.length - this.maxProducts);
    }
  }

  bindEvents() {
    const currentForms = Array.from(this.querySelectorAll('form[data-color-swatches]'));
    currentForms.forEach(form => {
      if (this.forms.has(form)) return;

      form.addEventListener('change', (event) => this.handleSelector(event));
      this.forms.add(form);
    });
  }

  async handleSelector(event) {
    const selector = event.target;
    const handle = selector.dataset.handle;
    await this.renderCard(handle);
    this.bindEvents();
  }

  getSectionToRender() {
    return ['[data-image]', '[data-labels]', '[data-price]', '[data-quick-add]']
  }

  async renderCard(handle) {
    const cacheKey = `${window.Shopify.country}-${window.Shopify.Locale}-cardCache-${handle}`;
    let html;

    const cachedHtmlString = sessionStorage.getItem(cacheKey);

    if (cachedHtmlString) {
      html = new DOMParser().parseFromString(cachedHtmlString, 'text/html');
    } else {
      const rootUrl = window.routes.root_url || '';
      const url = `${location.origin + rootUrl}/products/${handle}?view=card-product`;

      const response = await fetch(url);
      const responseText = await response.text();

      // Parse and cache in sessionStorage
      html = new DOMParser().parseFromString(responseText, 'text/html');
      sessionStorage.setItem(cacheKey, responseText);
    }

    const sourceCard = html.querySelector(`card-product[data-product-handle="${handle}"]`);

    for (let section of this.getSectionToRender()) {
      Utils.updateSource(this, html, section, true);
    }

    Object.keys(sourceCard.dataset).forEach(key => {

      this.dataset[key] = sourceCard.dataset[key];
    });

  }

  getColorSibling(sibling) {
    return `<label
                aria-label="color ${sibling.handle}"
                class="tw-h-12 tw-w-31 tw-rounded-none tw-cursor-pointer [&:has(input:checked)]:tw-border-1 [&:has(input:checked)]:tw-border-black "
                style="background: ${this.colors.find(color => color.code === sibling.colorCode)?.hex || '#eaeaea'}"
              >
              <input class="tw-sr-only" ${sibling.checked} type='radio' name="color-selector-${this.dataset.handle}" data-handle="${sibling.handle}" tabindex="0">
            </label>`
  }

  getColorQuery() {

    const query = `
     query @inContext(country: ${window.Shopify.country} , language: ${window.Shopify.locale.toUpperCase()}) {
      product(handle: "${this.dataset.productHandle}") {
        handle
        title
        products: metafield(key: "siblings", namespace: "elastick") {
          references(first: 250) {
            nodes {
              ... on Product {
                id
                handle,
                supplier_color: metafield(key: "supplier_color", namespace: "elastick") {
                  value
                }
               
              }
            }
          }
        }
      }
    }`;
    return this.utils.getGraphQLBody(query);
  }
}

customElements.define('card-product', CardProduct);
